const maintenanceConfig = {
  maintenance: {
    // set to true while online bookings are unavailable: shows the alert above the navigation
    // and a notice in the booking wizard, where the next button is disabled
    onlineBookingUnavailable: false,
  },
}

export default maintenanceConfig
